import React from 'react';
import styles from './Proof.css';
import { InlineText3, Sucess16 } from '@cian/ui-kit';

interface IProofProps {
  text: string;
}

export function Proof({ text }: IProofProps) {
  return (
    <div className={styles['proof']}>
      <div className={styles['icon']}>
        <Sucess16 color="primary_100" />
      </div>
      <InlineText3 color="gray60_100">{text}</InlineText3>
    </div>
  );
}
